import { QueryClient } from "@tanstack/react-query";
import { apiBaseUrl, createAttendeeApi, createHttpClient, isApiError } from "@rekati/api";
import { attendeeSession } from "../features/attendee-session/session-store";

export const http = createHttpClient({
  baseUrl: apiBaseUrl(),
  getToken: attendeeSession.token,
  onUnauthorized: () => attendeeSession.clear(),
});

/** The one instance every feature's queries and mutations call. */
export const api = createAttendeeApi(http);

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
      // docs/frontend-integration.md 8: never retry a 4xx.
      retry: (count, error) => count < 2 && (!isApiError(error) || error.isRetryable),
    },
    mutations: { retry: false },
  },
});

/** Query keys, in one place so an invalidation never misses. */
export const keys = {
  event: ["event"] as const,
  brand: ["brand"] as const,
  industries: ["industries"] as const,
  walkInState: ["walk-in"] as const,
  interestTags: ["interest-tags"] as const,
  me: ["attendee", "me"] as const,
  rsvps: ["attendee", "rsvps"] as const,
  surveyState: ["survey", "state"] as const,
};
